function togglePasswordVisibility(target) {
  const inputElementId = target.srcElement.dataset.forInput;
  if (!inputElementId) {
    throw new Error('No input element id found. Please add data-for-input in the element with the toggle visiblity click action.');
  }

  const inputElement = document.getElementById(inputElementId);
  if (!inputElement) {
    throw new Error(`No input element found for id ${inputElementId}.`);
  }

  if (inputElement.type === "password") {
    inputElement.type = "text";
    target.srcElement.classList.remove("eye-hidden");
    target.srcElement.classList.add("eye-opened");
  }
  else {
    inputElement.type = "password";
    target.srcElement.classList.add("eye-hidden");
    target.srcElement.classList.remove("eye-opened");
  }
}

function setUpPasswordsVisibilityToggler() {
  const els = document.getElementsByClassName("password-visibility-toggler");
  if (els) {
    for (let i = 0; i < els.length ; i++) {
      const el = els[i];
      el.addEventListener("click", togglePasswordVisibility, false);
    }
  }
}

document.addEventListener("DOMContentLoaded", setUpPasswordsVisibilityToggler, false);
